import styles from './index.module.css'
import { Button } from '@appkit4/react-components/button'
import classnames from 'classnames'

export const View = ({ label, className, size, width, isGray, ...props }) => {
    const style = {
        '--button-width': width
    }
    const grayClass = isGray ? styles.gray : ''
    const isOnlyIcon = !label && props.icon
    const onlyIconClass = isOnlyIcon ? styles.only_icon : ''
    return (
        <Button
            className={classnames(styles.default, styles[size], grayClass, onlyIconClass, className)}
            style={style}
            {...props}
        >
            {label}
        </Button>
    )
}
